import React from 'react';

import Bennar from '../Bennar/Bennar'
import Footer from '../Footer';
import ItemCardModal from '../SubMenu/ItemCardModal';
import SubMenu from './../SubMenu/SubMenu';

const Home = () => {
    return (
        <div>
            
            <Bennar></Bennar>
            <SubMenu></SubMenu>
            <Footer></Footer>
          
           
        </div>
    );
};

export default Home;